import React from 'react';
import {isMobile, isTablet} from 'react-device-detect';
import {useMedia} from 'react-use';
import {DesktopView, MobileView, TabletView} from "./views";
import {useDocumentDetail} from "./use-document-detail";
import {Loading} from "presentation/common";
import {ErrorMessage} from './error-message/error-message';

export const DocumentDetailPage = () => {
  const props = useDocumentDetail();
  const isWide = useMedia('(max-width: 800px)');

  if (props.isError || props.errorMessage) {
    return <ErrorMessage message={props.errorMessage} />;
  }

  if (props.isLoading) {
    return <Loading />;
  }

  if (isTablet) {
    return <TabletView {...props} />;
  }

  if (isMobile || isWide) {
    return (
      <div className="m-4">
        <MobileView {...props} />
      </div>
    );
  }

  return <DesktopView {...props}/>;
};
